import request from '../servises/request'
import axios from 'axios'
import { getToken } from '../servises/token'

export function getUsers(pr) {
    let params
    if (pr) {
        params = `?${pr}`
    }
    return request({
        url: pr ? `/user${params}` : '/user',
        method: 'GET'
    })
}

export function getTrashedUsers(pr) {
    let params
    if (pr) {
        params = `?${pr}`
    }
    const urlPath = '/users/trashed';

    return request({
        url: pr ? (urlPath + params) : urlPath,
        method: 'GET'
    })
}

export function restoreUser(user_id) {
    return request({
        url: `/user/${user_id}/restore`,
        method: 'POST',
    })
}

export function deleteUser(user_id) {
    return request({
        url: `/user/${user_id}`,
        method: 'DELETE'
    })
}

export function forceDeleteUser(user_id) {
    return request({
        url: `/user/${user_id}/force`,
        method: 'DELETE'
    })
}

export function userShow(user_id) {
    return request({
        url: `/user/${user_id}`,
        method: 'GET'
    })
}
export function userEmailDetails(email) {
    return request({
        url: `/email-logs/account-details`,
        method: 'POST',
        data: email
    })
}

export function userEmailLog(email) {
    return request({
        url: `/email-logs`,
        method: 'POST',
        data: email
    })
}

export function userScans({
    userId,
    pr
}) {
    return request({
        url: `/user/${userId}/report`,
        method: 'GET',
        params: pr
    })
}

export function getReport(scanId) {
    return request({
        url: `/scan/${scanId}/report`,
        method: 'GET'
    })
}

export function getTinderReport(scanId) {
    return request({
        url: `/tinder/${scanId}/report`,
        method: 'GET'
    })
}

export function getUserPayments(userId) {
    return request({
        url: `/user/${userId}/plan`,
        method: 'GET'
    })
}

export function getReportImage(url) {
    if (url.startsWith('http')) {
        const token = getToken();

        return axios({
            url: url,
            method: 'GET',
            responseType: 'arraybuffer',
            headers: {
                'Authorization': token,
                'Accept': 'application/json'
            }
        });
    }

    return request({
        url: url,
        method: 'GET',
        responseType: 'arraybuffer'
    });
}

export function updateUser(userId, data) {
    return request({
        url: `/user/${userId}`,
        method: 'PATCH',
        data: data
    })
}

export function resendVerification(userId, data) {
    return request({
        url: `/user/${userId}/resend-verification`,
        method: 'post'
    })
}

export function createUser(data) {
    return request({
        url: `/user`,
        method: 'POST',
        data: data
    })
}

export function getDisputeReport(params) {
    return request({
        url: `/user/generate-dispute-report`,
        method: 'POST',
        data: params,
        responseType: 'blob'
    })
}

export function getColdUsers(pr) {
    let params
    if (pr) {
        params = `?${pr}`
    }
    return request({
        url: pr ? `/cold${params}` : '/cold',
        method: 'GET'
    })
}

export function getSubscriberUsers(pr) {
    let params
    if (pr) {
        params = `?${pr}`
    }
    return request({
        url: pr ? `/newsletter${params}` : '/newsletter',
        method: 'GET'
    })
}
